import React from "react";
import { Container, Row, Card, CardBody } from "reactstrap";
import { FilterIcon, CheckIcon } from "mdi-react";
import ProfileAuditLog from "../../Users/UserDetails/Profile/components/ProfileAuditLog";
import * as auditlog from "../../../../shared/service/auditlog";

class AuditLog extends React.Component {
  state = {
    title: "Audit Logs",
    types: [],
  };

  updateTypeState = (type) => {
    let types = this.state.types;

    types.forEach((obj) => {
      if (obj.key === type.key) {
        obj.checked = !obj.checked;
      }
    });

    this.setState({ types }, () => {
      this.child.current.filter(this.state.types);
    });
  };

  componentDidMount() {
    this.child = React.createRef();
    auditlog.getEvents().then((types) => this.setState({ types }));
  }

  render() {
    return (
      <Container>
        <Row className="user-section">
          <Card className="filter-section">
            <div className="card__title">
              <h5 className="bold-text">Filters</h5>
              <FilterIcon color="#999" size={14} />
            </div>
            <div className="form wild-card-search">
              <div className="form__form-group search-bar">
                <span className="form__form-group-label">Event Type</span>
                <div className="form status-filters">
                  {this.state.types.map((type) => (
                    <div
                      key={type.key}
                      className="form__form-group-field checkbox-filter-field"
                      onClick={() => this.updateTypeState(type)}
                    >
                      <label
                        className="checkbox-btn checkbox-btn--colored"
                        htmlFor={"htmlFor" + type.key}
                      >
                        <input
                          className="checkbox-btn__checkbox"
                          type="checkbox"
                          checked={type.checked}
                          id={type.key}
                        />
                        <span
                          className="checkbox-btn__checkbox-custom"
                          style={
                            type.color
                              ? {
                                  background: type.color,
                                  borderColor: type.color,
                                }
                              : {}
                          }
                        >
                          <CheckIcon />
                        </span>
                        <span className="checkbox-btn__label">{type.name}</span>
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Card>
          <Card className="table-section form">
            <CardBody>
              <div className="card__title">
                <h5 className="bold-text">{this.state.title}</h5>
              </div>
              <ProfileAuditLog
                types={this.state.types}
                ref={this.child}
              ></ProfileAuditLog>
            </CardBody>
          </Card>
        </Row>
      </Container>
    );
  }
}

export default AuditLog;
